<template>
  <SeriesCard
    title="Usage record"
    :series="data"
    test-id="usage-record-series-card"
    :loading="loading"
  >
    <template #actions>
      <FormSelect
        v-model="selected"
        size="xs"
        :options="options"
        @change="refresh"
      />
    </template>
  </SeriesCard>
</template>
<script setup>
import { computed, defineAsyncComponent, onMounted, ref } from 'vue';
import { loadFetch } from '~/lib/services/helpers';
import { useStore3 } from '~/store/main';

import { storeToRefs } from 'pinia';
import FormSelect from '~/components/form/FormSelect.vue';
import { UsageRecordUsageRecordTypeEnum } from '@mailslurp/admin-sdk';

import SeriesCard from '~/components/series/SeriesCard.vue';
const store3 = useStore3();

const { seriesUsage: data } = storeToRefs(store3);
const loading = ref(false);
const selected = ref('');
const options = computed(() => {
  return [
    { value: '', text: 'All' },
    ...Object.values(UsageRecordUsageRecordTypeEnum).map((it) => ({
      value: it,
      text: it,
    })),
  ];
});
const refresh = async () => {
  await loadFetch(
    () =>
      store3.getSeriesUsage({
        usageRecordType: selected.value === '' ? undefined : selected.value,
        endDate: undefined,
        startDate: undefined,
      }),
    store3,
    loading,
  );
};
onMounted(async () => {
  await refresh();
});
</script>
